export default function videoThumbGeral() {
    document.addEventListener('DOMContentLoaded', () => {
        // Seleciona todos os containers com data-video
        const videoContainers = document.querySelectorAll('[data-video]');

        videoContainers.forEach((container) => {
            const videoUrl = container.dataset.video;
            if (!videoUrl) return;

            const img = container.querySelector('img');
            if (!img) return;

            // Verifica se é um link do YouTube
            const youtubeRegex = /(?:youtube\.com\/.*v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            const match = videoUrl.match(youtubeRegex);

            if (match && match[1]) {
                const videoId = match[1];
                const thumbUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
                img.src = thumbUrl;
                return; // não precisa gerar frame
            }

            const cacheKey = `thumb_${btoa(videoUrl)}`;
            const cachedThumb = localStorage.getItem(cacheKey);

            if (cachedThumb) {
                img.src = cachedThumb;
                return;
            }

            const video = document.createElement('video');
            video.src = videoUrl;
            video.crossOrigin = 'anonymous';
            video.muted = true;
            video.playsInline = true;

            video.addEventListener('loadeddata', () => {
                try {
                    video.currentTime = 0.5;

                    video.addEventListener('seeked', () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;
                        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

                        const thumb = canvas.toDataURL('image/webp', 0.8);
                        img.src = thumb;

                        try { localStorage.setItem(cacheKey, thumb); }
                        catch (e) { console.warn('Falha ao salvar cache', e); }
                    }, { once: true });
                } catch (err) {
                    console.error('Erro ao gerar thumbnail', err);
                }
            });

            video.addEventListener('error', (e) => {
                console.error('Falha ao carregar vídeo:', videoUrl, e);
            });
        });
    });
}
